import React, { useState, useEffect } from 'react';
import CitationResult from '../components/CitationResult';
import { formatURL } from '../utils/citationHelpers';

function WikipediaForm() {
  const [formData, setFormData] = useState({
    title: '',
    year: '',
    day: '',
    month: '',
    url: ''
  });
  const [result, setResult] = useState(null);
  const [liveResult, setLiveResult] = useState(null);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Genera una vista previa en tiempo real
  useEffect(() => {
    if (formData.title && formData.year) {
      generatePreview();
    } else {
      setLiveResult(null);
    }
  }, [formData]);

  const formatDate = () => {
    const { year, month, day } = formData;
    if (!year) return '';

    if (day && month) {
      const monthNames = {
        '01': 'enero', '02': 'febrero', '03': 'marzo', '04': 'abril',
        '05': 'mayo', '06': 'junio', '07': 'julio', '08': 'agosto',
        '09': 'septiembre', '10': 'octubre', '11': 'noviembre', '12': 'diciembre'
      };
      return `${year}, ${parseInt(day)} de ${monthNames[month]}`;
    } else if (month) {
      const monthNames = {
        '01': 'enero', '02': 'febrero', '03': 'marzo', '04': 'abril',
        '05': 'mayo', '06': 'junio', '07': 'julio', '08': 'agosto',
        '09': 'septiembre', '10': 'octubre', '11': 'noviembre', '12': 'diciembre'
      };
      return `${year}, ${monthNames[month]}`;
    }
    return year;
  };

  const generatePreview = () => {
    const citation = {
      narrative: null, // No existe cita narrativa cuando el título es el autor
      parenthetical: `("${formData.title}", ${formData.year})`
    };

    const dateFormatted = formatDate();
    const formattedUrl = formatURL(formData.url);

    let referenceText = `${formData.title}. (${dateFormatted}). En <em>Wikipedia</em>`;
    
    if (formattedUrl) {
      referenceText += `. ${formattedUrl}`;
    } else {
      referenceText += '.';
    }

    const reference = {
      html: referenceText,
      text: referenceText.replace(/<[^>]*>/g, '')
    };

    setLiveResult({ citation, reference });
  };

  const generateCitation = () => {
    if (!formData.title || !formData.year) {
      alert('Generador APA, séptima edición dice:\n\nPor favor, completa todos los campos obligatorios.');
      return;
    }

    const citation = {
      narrative: null, // No existe cita narrativa cuando el título es el autor
      parenthetical: `("${formData.title}", ${formData.year})`
    };

    const dateFormatted = formatDate();
    const formattedUrl = formatURL(formData.url);

    let referenceText = `${formData.title}. (${dateFormatted}). En <em>Wikipedia</em>`;
    
    if (formattedUrl) {
      referenceText += `. ${formattedUrl}`;
    } else {
      referenceText += '.';
    }

    const reference = {
      html: referenceText,
      text: referenceText.replace(/<[^>]*>/g, '')
    };

    setResult({ citation, reference });
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2 dark:text-gray-100">Artículo de Wikipedia</h1>
        <p className="text-gray-600 dark:text-gray-400">Artículos de la enciclopedia Wikipedia</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-6 dark:bg-gray-800 dark:border-gray-700">
          <div>
            <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
              Título del artículo *
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
              required
            />
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div>
              <label htmlFor="year" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
                Año *
              </label>
              <input
                type="number"
                id="year"
                name="year"
                value={formData.year}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                required
              />
              <p className="text-xs text-gray-500 mt-1 dark:text-gray-400">
                Del historial de la página
              </p>
            </div>
            <div>
              <label htmlFor="day" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
                Día
              </label>
              <input
                type="number"
                id="day"
                name="day"
                value={formData.day}
                onChange={handleInputChange}
                min="1"
                max="31"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
              />
              <p className="text-xs text-gray-500 mt-1 dark:text-gray-400">
                Del historial de la página
              </p>
            </div>
            <div>
              <label htmlFor="month" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
                Mes
              </label>
              <select
                id="month"
                name="month"
                value={formData.month}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
              >
                <option value="">Seleccionar</option>
                <option value="01">Enero</option>
                <option value="02">Febrero</option>
                <option value="03">Marzo</option>
                <option value="04">Abril</option>
                <option value="05">Mayo</option>
                <option value="06">Junio</option>
                <option value="07">Julio</option>
                <option value="08">Agosto</option>
                <option value="09">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
              <p className="text-xs text-gray-500 mt-1 dark:text-gray-400">
                Del historial de la página
              </p>
            </div>
          </div>

          <div>
            <label htmlFor="url" className="block text-sm font-medium text-gray-700 mb-1 dark:text-gray-300">
              URL *
            </label>
            <input
              type="url"
              id="url"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
              placeholder="URL del artículo con el parámetro oldid"
              required
            />
            <p className="text-xs text-gray-500 mt-1 dark:text-gray-400">
              Usar la URL permanente del historial, que incluye el parámetro "oldid"
            </p>
          </div>

          <button
            type="button"
            onClick={generateCitation}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Generar cita y referencia
          </button>
        </div>

        <div className="space-y-6">
          {!result && liveResult && (
            <CitationResult
              citation={liveResult.citation}
              reference={liveResult.reference}
              livePreview={true}
            />
          )}
          <CitationResult
            citation={result?.citation}
            reference={result?.reference}
          />
        </div>
      </div>
    </div>
  );
}

export default WikipediaForm;